import { MooringAfterArrival } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const MOORING_AFTER_ARRIVAL_DATA_TAG = 'MooringAfterArrival';
export default class MooringAfterArrivalParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_AFTER_ARRIVAL, FIXED_PROTOCOL_CONTENT_TYPE_IDS.MOORING_AFTER_ARRIVAL, MOORING_AFTER_ARRIVAL_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            port: 'port',
            type: 'type',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new MooringAfterArrival(props.port, props.type, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.port,
            };
            data.port = link;
        }
        return data;
    }
}
//# sourceMappingURL=MooringAfterArrivalParser.js.map